import { ServiceBooking } from '@mirai/services';

import { FormCancel } from './Booking.FormCancel';
import { FormEdit } from './Booking.FormEdit';
import { FormEditBoard } from './Booking.FormEditBoard';
import { FormEditDate } from './Booking.FormEditDate';
import { FormEditOccupation } from './Booking.FormEditOccupation';
import { FormResend } from './Booking.FormResend';
import { ACTION, STATE } from '../Booking.constants';
import { L10N } from '../Booking.l10n';
import * as style from '../Booking.module.css';

const {
  CANCEL,
  EDIT,
  EDIT_BOARD,
  EDIT_BOARD_CONFIRM,
  EDIT_DATE,
  EDIT_OCCUPATION,
  EDIT_OCCUPATION_CONFIRM,
  RESEND,
  SHOW_CALENDAR,
} = ACTION;

const ACTION_VALUES = Object.values(ACTION);
const DEFAULT_ACTION = RESEND;

const ACTION_CONFIG = {
  [CANCEL]: {
    Form: FormCancel,
    editLayout: false,
    fit: false,
    submitL10N: L10N.ACTION_CANCEL,
    successL10N: L10N.NOTIFICATION_CANCEL_BOOKING_SUCCESS,
    titleL10N: L10N.ACTION_CANCEL_BOOKING,
    state: STATE.CANCELLED,
    request: ({ form, id, idHotel, pinCode, token }) => ServiceBooking.cancel({ id, idHotel, pinCode, token, ...form }),
  },
  [EDIT]: {
    Form: FormEdit,
    editLayout: false,
    fit: false,
    submitL10N: L10N.ACTION_POSTPONE,
    successL10N: L10N.NOTIFICATION_EDIT_BOOKING_SUCCESS,
    titleL10N: L10N.ACTION_EDIT_BOOKING,
    state: STATE.POSTPONED,
    request: ({ form, id, idHotel, pinCode, token }) =>
      ServiceBooking.postpone({ id, idHotel, pinCode, token, ...form }),
  },
  [EDIT_DATE]: {
    Form: FormEditDate,
    backAction: SHOW_CALENDAR,
    className: style.modalConfirmDialog,
    editLayout: true,
    fit: true,
    submitL10N: L10N.ACTION_CONFIRM,
    successL10N: L10N.NOTIFICATION_EDIT_DATE_SUCCESS,
    titleL10N: L10N.ACTION_EDIT_DATE,
    warningOn404: true,
    getFormProps: ({ responseCalendar }) => ({ responseCalendar }),
    request: ({ form, id, token }) => ServiceBooking.modification.date.confirm({ id, token, ...form }),
  },
  [EDIT_BOARD_CONFIRM]: {
    Form: FormEditBoard,
    backAction: EDIT_BOARD,
    className: style.modalConfirmDialog,
    editLayout: true,
    fit: true,
    submitL10N: L10N.ACTION_CONFIRM,
    successL10N: L10N.NOTIFICATION_EDIT_BOARD_SUCCESS,
    titleL10N: L10N.ACTION_EDIT_BOARD,
    getFormProps: ({ responseBoard }) => ({ responseBoard }),
    request: ({ form, id, token }) => ServiceBooking.modification.board.confirm({ id, token, ...form }),
  },
  [EDIT_OCCUPATION_CONFIRM]: {
    Form: FormEditOccupation,
    backAction: EDIT_OCCUPATION,
    className: style.modalConfirmDialog,
    editLayout: true,
    fit: true,
    submitL10N: L10N.ACTION_CONFIRM,
    successL10N: L10N.NOTIFICATION_EDIT_OCCUPATION_SUCCESS,
    titleL10N: L10N.ACTION_EDIT_OCCUPATION,
    getFormProps: ({ responseOccupation }) => ({ responseOccupation }),
    request: ({ form, id, token }) => ServiceBooking.modification.occupation.confirm({ id, token, ...form }),
  },
  [RESEND]: {
    Form: FormResend,
    disableSubmitOnError: true,
    editLayout: false,
    fit: false,
    submitL10N: L10N.ACTION_SEND,
    successL10N: L10N.NOTIFICATION_EMAIL_SUCCESS,
    titleL10N: L10N.ACTION_RESEND_BOOKING,
    request: ({ form, id, idHotel, pinCode, token }) => ServiceBooking.email({ id, idHotel, pinCode, token, ...form }),
  },
};

const getModalActionConfig = (action) => ACTION_CONFIG[ACTION_VALUES.includes(action) ? action : DEFAULT_ACTION];

export { getModalActionConfig };
